import React from 'react'
import Icons from '../Icons'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const SpinnerInput = ({value, onChange, min, max, step}) => {
  const increment = () => {
    let newValue = value + step >= max ? max : value + step
    onChange(newValue)
  }

  const decrement = () => {
    let newValue = value - step <= min ? min : value - step
    onChange(newValue)
  }

  return (
    <Container>
      <StyledButton onClick={decrement}>
        <Icons icon="MINUS" />
      </StyledButton>
      <StyledValue>
        <ValueText>{value}</ValueText>
      </StyledValue>
      <StyledButton onClick={increment}>
        <Icons icon="PLUS" />
      </StyledButton>
    </Container>
  )
}

SpinnerInput.defaultProps = {
  value: 0,
  min: -Infinity,
  max: Infinity,
  step: 1
}

SpinnerInput.propTypes = {
  value: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func
}

export default SpinnerInput

const Container = styled.div`
  display: flex;
  max-width: 148px;
  justify-content: space-between;
  height: 46px;
  border-radius: 6px;
  background-color: #f3f5fb;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.3px;
  color: #a4a9b7;
  cursor: pointer;
  box-sizing: border-box;
`

const StyledButton = styled.button`
  width: 46px;
  height: 46px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 1px 6px 0 rgba(51, 149, 254, 0.38);
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  outline: none;
  user-select: none;
`

const StyledValue = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 100%;
  user-select: none;
`

const ValueText = styled.div`
  font-size: 16px;
  color: #a4a9b7;
`
